import { render, staticRenderFns } from "./BaseSelect.vue?vue&type=template&id=58951315&scoped=true"
import script from "./BaseSelect.vue?vue&type=script&lang=js"
export * from "./BaseSelect.vue?vue&type=script&lang=js"
import style0 from "./BaseSelect.vue?vue&type=style&index=0&id=58951315&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58951315",
  null
  
)

export default component.exports